import type { SLIDER_TYPES } from 'hb-builder/components/BuilderComponents/dynamic/Slider/SliderLayouts/types';
import type { Option } from 'hb-builder/utils/dynamicSelectorsHelpers';

const OPTION_VALUES: Option[] = [
  { value: 4, label: '4' },
  { value: 8, label: '8' },
  { value: 12, label: '12' },
  { value: 16, label: '16' },
];

export type NbItemsSliderOptions = {
  [key in Exclude<SLIDER_TYPES, 'users'>]: Option[];
};

export const nbItemsSliderOptions: NbItemsSliderOptions = {
  empty: [],
  discussions: OPTION_VALUES,
  events: OPTION_VALUES,
  posts: OPTION_VALUES,
  topics: OPTION_VALUES,
  news: OPTION_VALUES,
};

export const isValueAnOption = (selectOptions, selectedValue) =>
  selectOptions?.some((option) => option.value === selectedValue);
